'use client';

/**
 * McpClaudeFinalCTA — closes the page with the standard V3 final CTA
 * (cyan halo, two-clause headline, primary + secondary CTAs).
 */

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const McpClaudeFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#22D3EE"
      ariaLabel={t('McpClaude/FinalCTA/aria_label')}
      copy={{
        headlineA: t('McpClaude/FinalCTA/title1'),
        headlineB: t('McpClaude/FinalCTA/title2'),
        subhead: t('McpClaude/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('McpClaude/FinalCTA/cta_primary'),
          href: `/${lang}/contact-us`,
        },
        ctaSecondary: {
          label: t('McpClaude/FinalCTA/cta_secondary'),
          href: `/${lang}/pricing`,
        },
      }}
    />
  );
};

export default McpClaudeFinalCTA;
